import api from './client'

// SISTEMA → Correos: registro de todo mail que sale de LGR + su estado en Brevo.
export const emailsApi = {
  listar:  (params) => api.get('/emails', { params }),
  resumen: (params) => api.get('/emails/resumen', { params }),
  ver:     (id)     => api.get(`/emails/${id}`),
}
